import { initializeApp } from 'firebase/app'
import { getMessaging, getToken, onMessage } from 'firebase/messaging'

const firebaseConfig = {
  apiKey: 'AIzaSyDdwWE-69Ijms8ajlCc4roIe90nc8VwBZ4',
  authDomain: 'ladies-484d0.firebaseapp.com',
  projectId: 'ladies-484d0',
  storageBucket: 'ladies-484d0.firebasestorage.app',
  messagingSenderId: '650723329278',
  appId: '1:650723329278:web:24dc446736f2fe7ec391af',
  measurementId: 'G-D1DNQ29WFQ',
}

const app = initializeApp(firebaseConfig)
const messaging = getMessaging(app)

export { messaging, getToken, onMessage }
